/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, pxToEmWithBaseline } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : CODE SELECTOR : STYLES --------------- ++++++++++ */
export default theme => ({
	codeselector: {
        fontSize: pxToEm(16),
        lineHeight: pxToEmWithBaseline({ value: 20 , fontSizeBaseline: 16 }),
        '& .codepiece': {
			'& p': {
				fontSize: pxToEm(14),
                marginTop: pxToEmWithBaseline({ value: 12 , fontSizeBaseline: 14 }),
			},
			'& h3': {
                fontSize: pxToEm(16),
                fontWeight: 'bold'
			},
			'& .group': {
				'& .field': {
					maxWidth: pxToEmWithBaseline({ value: 513 , fontSizeBaseline: 16 }),
                    marginTop: pxToEmWithBaseline({ value: 12 , fontSizeBaseline: 16 }),
                    display: 'block',
					'& .textfield': {
                        fontSize: pxToEm(14)
                    }
				},
				'& .button': {
					display: 'block',
					marginTop: pxToEmWithBaseline({ value: 12 , fontSizeBaseline: 14 }),
					fontSize: pxToEm(14),
					width: pxToEmWithBaseline({ value: 80 , fontSizeBaseline: 14 }),
					height: pxToEmWithBaseline({ value: 48 , fontSizeBaseline: 14 })
				}
			}
        },
		'& .codemessage': {
            // margin: replacePXinStringWithEM('55px 0'),
            maxWidth: pxToEmWithBaseline({ value: 513 , fontSizeBaseline: 16 }),
            marginTop: pxToEmWithBaseline({ value: 55 , fontSizeBaseline: 16 }),
            marginBottom: pxToEmWithBaseline({ value: 55 , fontSizeBaseline: 14 }),
            '&:last-child': { marginBottom: '0' },
            '& .text': {
                fontSize: pxToEm(14),
                '& .highlight': { color: theme.color.primary.medium.swatch }
            }
        }
    }
});
